
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/palette/[id]",
      function () {
        return require("private-next-pages/palette/[id].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/palette/[id]"])
      });
    }
  